import { gql } from 'graphql-tag';

const SHARE_LISTING_WITH_NYLAS = gql`
  mutation ShareListingWithNylas($params: ShareListingWithNylasParams!) {
    shareListingWithNylas(params: $params)
  }
`;

export default SHARE_LISTING_WITH_NYLAS;
